import Command from './Command.js';

/**
 * TrainCommand Class
 *
 * The TrainCommand class extends the Command class, adding specific properties and behavior for a train controller.
 * It inherits the ability to store and convert the configuration of a controller into an HTML representation,
 * while adding train-specific attributes and behaviors.
 */
export default class TrainCommand extends Command {
	reversed;

	/**
	 * Constructor
	 *
	 * Initializes a new instance of the TrainCommand class with the specified dcc and color,
	 * sets the device type to 'Train', and initializes the reversed property to false.
	 *
	 * @param {string} dcc - The unique identifier for the controller used.
	 * @param {string} color - The color identifier used to style and identify the controller.
	 */
	constructor(dcc, color) {
		super(dcc, color);
		this.reversed = false;
		this.device = 'Train';
	}

	/**
	 * Generates an HTML string that represents the train controller.
	 * This HTML includes a label, a vertically oriented range input, and two buttons (stop and trash) with specific styling.
	 *
	 * @returns {string} A string of HTML representing the train controller.
	 */
	commandToHtml() {
		return super.commandToHtml();
	}
}
